var app = angular.module('leonardo');

var WidgetFolderRequirements = function() {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/folder-requirements.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      var ngModelCtrl = ctrls[1];
      scope.list = [];
      scope.error = null;
      scope.adding = false;

      scope.addRequirement = function() {
        if (isNull(scope.name)) {
          scope.error = 'This field is required.';
          return;
        }
        scope.error = null;
        scope.list.push({
          id: null,
          name: scope.name
        });

        ngModelCtrl.$setViewValue(scope.list);
        ngModelCtrl.$render();
        scope.adding = true;
        scope.name = '';
      };

      ngModelCtrl.$render = function() {
        scope.list = ngModelCtrl.$viewValue ? ngModelCtrl.$viewValue : [];
      };

      scope.removeRequirement = function(index) {
        scope.list.splice(index, 1);
      };

      scope.$watch('name', function (newValue, oldValue) {
        if (newValue === oldValue) return;
        if (newValue) {
          scope.error = null;
        }
        else if (!scope.adding) {
          scope.error = 'This field is required.';
        }
        scope.adding = false;
      });
    }
  };
};

app.directive('widgetFolderRequirements', [WidgetFolderRequirements]);
